module.exports = __webpack_public_path__ + "static/media/signupmobile.2b69b869.svg";